import { Spin } from "antd"
export default function Loading() {
  return <div className="w-full min-h-[50vh] flex justify-center items-center flex-col">
    <Spin size="large" ></Spin>
    <div className="text-[#841EEC] mt-2">Loading...</div>
  </div>
}